interface TopicItem {
  label: string;
  hot: boolean;
}

const topics: TopicItem[] = [
  { label: '奔跑吧', hot: true },
  { label: '脱口秀大会', hot: true },
  { label: '真人秀推荐', hot: true },
  { label: '密室大逃脱', hot: true },
  { label: '欢乐喜剧人', hot: false },
  { label: '向往的生活', hot: false },
  { label: '搞笑综艺合集', hot: true },
  { label: '中餐厅', hot: false },
  { label: '中国好声音', hot: false },
  { label: '心动的信号', hot: false },
  { label: '高清综艺在线', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            话题标签
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            大家都在讨论
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            热门的综艺话题和讨论标签，看看哪些综艺正在被热议
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className={`inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-medium border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 border-primary-200 hover:bg-primary-200 hover:border-primary-300'
                  : 'bg-background-50 text-foreground-600 border-background-200/70 hover:border-foreground-300 hover:text-foreground-800'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <i className="ri-fire-line text-accent-500 text-xs"></i>
              )}
            </a>
          ))}
        </div>

        <p className="text-center text-xs text-foreground-500 mt-6">
          带火焰标识的为当前最热话题
        </p>
      </div>
    </section>
  );
}